
import { useState } from 'react';
import { Member } from '../../types/memberTypes';

export const useMemberDialogs = () => {
  // Use useState with logging to help debug
  const [showAddMemberDialog, setShowAddMemberDialog] = useState(false);
  
  // Define a wrapped setter that includes logging
  const setShowAddMemberDialogWithLogging = (value: boolean) => {
    console.log(`Setting showAddMemberDialog to: ${value}`);
    setShowAddMemberDialog(value);
  };
  
  const [showDeleteMemberDialog, setShowDeleteMemberDialog] = useState(false);
  const [showPrimaryOwnerDialog, setShowPrimaryOwnerDialog] = useState(false);
  const [showTransferOwnershipDialog, setShowTransferOwnershipDialog] = useState(false);
  const [showLeavePortfolioDialog, setShowLeavePortfolioDialog] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState<Member | null>(null);
  const [memberToPromote, setMemberToPromote] = useState<Member | null>(null);

  return {
    showAddMemberDialog,
    setShowAddMemberDialog: setShowAddMemberDialogWithLogging,
    showDeleteMemberDialog,
    setShowDeleteMemberDialog,
    showPrimaryOwnerDialog,
    setShowPrimaryOwnerDialog,
    showTransferOwnershipDialog,
    setShowTransferOwnershipDialog,
    showLeavePortfolioDialog,
    setShowLeavePortfolioDialog,
    memberToDelete,
    setMemberToDelete,
    memberToPromote,
    setMemberToPromote,
  };
};
